const typography = {
  fontFamily: `'Lexend', 'Roboto', 'Helvetica', 'Arial', sans-serif`,

  // Display/Big numbers
  displayLarge: {
    fontSize: "48px",
    fontWeight: 700,
    lineHeight: 1.2,
    "@media (max-width:900px)": {
      fontSize: "42px",
    },
    "@media (max-width:600px)": {
      fontSize: "36px",
    },
  },
  displayMedium: {
    fontSize: "42px",
    fontWeight: 700,
    lineHeight: 1.2,
    "@media (max-width:900px)": {
      fontSize: "36px",
    },
    "@media (max-width:600px)": {
      fontSize: "32px",
    },
  },
  displaySmall: {
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: 1.2,
    "@media (max-width:900px)": {
      fontSize: "32px",
    },
    "@media (max-width:600px)": {
      fontSize: "28px",
    },
  },

  displaySmallSemiBold: {
    fontSize: "36px",
    fontWeight: 500,
    lineHeight: 1.2,
    "@media (max-width:900px)": {
      fontSize: "32px",
    },
    "@media (max-width:600px)": {
      fontSize: "28px",
    },
  },

  // Headings
  cost_text: {
    fontSize: "22px",
    fontWeight: 600,
    lineHeight: 1.5,
    color:'#000000DE'

  },
  h1: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: 1.5,
    color:'#000000'

  },
  h2: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.5,
    color:'#000000'
  },

//Body
  bodyLarge: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.5,
    // color:'#505050'
  },
  bodySmall: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: 1.5,
    // color:'#5A5A5A'
  },

// Badge text
  badgeLabel: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: 1.5,
  },


  // Stats and numbers
  statLarge: {
    fontSize: "42px",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  statMedium: {
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  statSmall: {
    fontSize: "30px",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  statExtraSmall: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: 1.2,
  },

  // Card titles
  cardTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: 1.5,
  },
  cardSubtitle: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.5,
    color: "#505050",
  },

};

// Helper function to get typography styles
export const getTypographyStyles = (variant) => {
  return typography[variant] || typography.bodyMedium;
};

// Predefined combinations for common use cases
export const typographyVariants = {
  // Page headers
  pageTitle: typography.h2,
  sectionTitle: typography.h4,
  subsectionTitle: typography.h6,

  // Card headers
  cardHeader: typography.cardTitle,
  cardSubHeader: typography.cardSubtitle,

  // Stats displays
  statPrimary: typography.statLarge,
  statSecondary: typography.statSmall,

  // Body text
  bodyPrimary: typography.bodyMedium,
  bodySecondary: typography.bodySmall,

  // Helper text
  helper: typography.captionSmall,

  // Labels
  label: typography.titleExtraSmall,

  // Values
  valuePrimary: typography.statMedium,
  valueSecondary: typography.statExtraSmall,
};

export default typography;
